import { LayoutGrid, Table2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { ViewMode } from '@/hooks/use-view-mode'

/** Board ⇄ table segmented toggle for the board screens. */
export function ViewModeToggle({
  mode,
  onChange,
}: {
  mode: ViewMode
  onChange: (mode: ViewMode) => void
}) {
  return (
    <div className="border-border bg-surface flex items-center gap-px rounded-lg border p-0.5">
      {(
        [
          ['board', LayoutGrid, 'Board view'],
          ['table', Table2, 'Table view'],
        ] as const
      ).map(([m, Icon, label]) => (
        <Button
          key={m}
          size="sm"
          variant={mode === m ? 'secondary' : 'ghost'}
          className="h-6 px-2"
          aria-label={label}
          aria-pressed={mode === m}
          onClick={() => onChange(m)}
        >
          <Icon className="size-3.5" />
        </Button>
      ))}
    </div>
  )
}
